import { render } from "./UploadProfilePicture.vue?vue&type=template&id=f338117c"
import script from "./UploadProfilePicture.vue?vue&type=script&lang=js"
export * from "./UploadProfilePicture.vue?vue&type=script&lang=js"

import "./UploadProfilePicture.vue?vue&type=style&index=0&id=f338117c&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__